import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import { throwIfHasNoPermission } from "@/utils/permissions";

import { fetchCategoriesQueryOptions } from "@/modules/handbook/admin/services";

import HandbookCategoriesList from "../../../../components/HandbookCategoriesList";

export const Route = createFileRoute(
  "/admin/_panel/_handbook/handbook/categories/",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(
      context.user,
      "handbook.handbook-entry-category.view",
    );

    return {
      crumb: [
        {
          label: context.t("Categories", { ns: "core.shared" }),
        },
      ],
    };
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(fetchCategoriesQueryOptions()),
});

function RouteComponent() {
  const { t } = useTranslation("handbook.admin");

  return (
    <Container
      title={t("Categories", {
        ns: "core.shared",
      })}
      description={t("Manage Handbook", {
        ns: "handbook.admin",
      })}
    >
      <HandbookCategoriesList />
    </Container>
  );
}
